<template>
  <div class="form-group">
    <div v-if="withLabel" class="grey mb5">{{ label ?? name }}</div>
    <select class="form-select" :name="name" v-validate="rules" v-model="inputValue" :disabled="disabled">
      <option disabled value="">{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">{{ option?.text }}</option>
    </select>
    <small class="text-danger text-sm" v-show="errors.has(name)">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'FieldSelect',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Choose One'
    },
    withLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator']
};
</script>
